import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { formatDistance } from '../../../../utils';
const LastUpdate = ({ lastUpdate, className }) => {
    if (!lastUpdate) {
        return null;
    }
    const { t } = useTranslation('FlightStatus');
    const [currentTime, setCurrentTime] = useState(new Date());
    const updateCurrentDateInterval = 30 * 1000;
    const timer = setInterval(() => {
        setCurrentTime(new Date());
    }, updateCurrentDateInterval);
    useEffect(() => {
        return () => clearInterval(timer);
    }, []);
    return (React.createElement("div", { className: className }, t('The latest data update was performed', {
        distance: formatDistance(lastUpdate, currentTime, { addSuffix: true })
    })));
};
export default LastUpdate;
